export default {
  // header
  'develop': 'Develop',
  'representative': 'Representative',
  'resources': 'Resources',
  'maroscan': 'Maro scan',
  'menu': 'menu',
  'close': 'close',

  // footer
  'footer_home': 'Home',
  'footer_about': 'About',
  'footer_ecosystem': 'Ecosystem',
  'footer_developer': 'Developer',
  'footer_media': 'Social media',
  'about_contant4_time1': 'July, 2020',
  'about_contant4_time1_txt1': 'Maro Rebranding',
  'about_contant4_time2': 'June, 2020',
  'about_contant4_time2_txt1': 'WorkBox Launched',
  'about_contant4_time3': 'March, 2020',
  'about_contant4_time3_txt1': 'Over  10,000,000 blocks produced',
  'about_contant4_time4': 'December, 2019',
  'about_contant4_time4_txt1': 'Stablecoin Launched',
  'about_contant4_time5': 'September, 2019',
  'about_contant4_time5_txt1': 'Tigris Protocol Launched',
  'about_contant4_time6': 'August, 2019',
  'about_contant4_time6_txt1': 'Acorn Protocol Beta Launched',
  'about_contant4_time7': 'July, 2019',
  'about_contant4_time7_txt1': 'Slave Network Launched',
  'about_contant4_time8': 'April, 2019',
  'about_contant4_time8_txt1': 'Maro Connect Launched',
  'about_contant4_time9': 'March, 2019',
  'about_contant4_time9_txt1': 'Mainnet Launched',
  'about_contant4_time10': 'August, 2018',
  'about_contant4_time10_txt1': 'Maro Scan Launched',
  'about_contant4_time11': 'January, 2018',
  'about_contant4_time11_txt1': 'Maro Foundation Founded',

  // home
  'content1_txt': 'Aplikasi dompet mobile aman yang bisa digunakan untuk mengatur aset anda di Blockchain Maro dengan mulus.',
  'content1_download': 'Download',

  'content2_h3': 'Maro Connect menghubungkan anda dengan MARO',
  'content2_p': 'Dengan MARO Connect, anda bisa memilih untuk Representatif, mengumpulkan imbalan, mengirim aset, membayar, dan lebih banyak lagi',
  'content2_h5_1': 'Mudah untuk digunakan',
  'content2_txt_1': 'Anda bisa membuat sebuah akun dan menggunakan MARO Connect seperti itu saja',
  'content2_h5_2': 'Aman dan terjamin',
  'content2_txt_2': 'Dengan perangkat seluler aman anda, anda bisa menyimpan MARO anda aman dan terjaga. Apabila anda kehilangan perangkat anda, anda bisa dengan mudah mengembalikan akun anda dengan Kunci Mnemonic anda atau Private Key di perangkat baru',
  'content2_h5_3': 'Transaksi yang cepat',
  'content2_txt_3': 'Maro Blockchain memungkinkan untuk transaksi cepat dan throughput yang tinggi karena menyelesaikan efek bottleneck yang disaksikan pada platform blockchain lainnya',

  'content3_h3': 'Maro Connect adalah dompet seluler yang di desain ramah pengguna',
  'content3_p': 'Sebagai dompet selular yang mudah digunakan, MARO Connect memungkinkan anda untuk secara aman menyimpan aset anda. Maro Blockchain membangun sebuah ekonomi token yang berkelanjutan dan infrastruktur terbuka yang menyediakan sarana bagi semua warga dunia untuk terhubung secara mulus ke ekonomi global untuk mendapatkan lebih banyak peluang untuk kemakmuran',
  'content3_link': 'Lihat lebih>'
}



// WEBPACK FOOTER //
// ./src/i18n/id.js